import { render, staticRenderFns } from "./IISSiteGetPostRequestsChart.vue?vue&type=template&id=240a825f&"
import script from "./IISSiteGetPostRequestsChart.vue?vue&type=script&lang=js&"
export * from "./IISSiteGetPostRequestsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports